import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import '../ActionTwoHopProgressTable.css';
import DeviceTableCell from 'components/features/DeviceView/DeviceTable/DeviceTableCells/DeviceTableCell';

const ActionTwoHopProgressTableScoreCell = (props) => {
  const twoHopScoreDictionary = useSelector(
    (store) => store.ui.actionsPage.twoHopScoreDictionary?.[props.alignmentId]
  );

  return <DeviceTableCell center={true} displayString={twoHopScoreDictionary?.[props.rowKey]} />;
};

export default memo(ActionTwoHopProgressTableScoreCell);
